module.exports = __webpack_public_path__ + "static/taiwan-e0da9b4efcd2a2da612cdbd1d2486e31.jpg";